export const ladderLogo = '/assets/images/ladder-logo.svg';
